import { OptionModel } from "../../common/types/OptionModel";

export const currencySymbole:OptionModel[] = [
    {
        value: "$",
        label: "$"
    },
    {
        value: "€",
        label: "€"
    },
    {
        value: "£",
        label: "£"
    }
]